module.exports = __webpack_public_path__ + "1248c75a6a4a95ef84291c0689ec1b89.png";